import React from 'react';
import { motion } from 'framer-motion';
import { Radio as RadioIcon, ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function Radio() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12">
      {/* Back Button */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="absolute top-8 left-8"
      >
        <Link
          to="/"
          className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition group"
        >
          <ArrowLeft size={20} weight="bold" className="group-hover:-translate-x-1 transition-transform" />
          <span className="text-sm font-semibold">Back to Hub</span>
        </Link>
      </motion.div>

      {/* Main Radio Console */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full"
      >
        {/* Acoustic Console Container */}
        <div className="glass-panel p-8 border-2 border-purple-500/40 rounded-2xl bg-gradient-to-br from-purple-900/30 via-black/50 to-cyan-900/30 backdrop-blur-xl relative overflow-hidden shadow-2xl">
          {/* Enhanced gradient border glow effect */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-purple-500/40 via-cyan-500/40 to-purple-500/40 opacity-60 blur-2xl -z-10" />
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-purple-600/20 to-cyan-600/20 animate-pulse opacity-30 -z-5" />
          
          {/* PROMINENT HEADER */}
          <div className="text-center mb-8">
            <motion.div 
              className="flex items-center justify-center gap-4 mb-4"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <RadioIcon size={40} weight="duotone" className="text-purple-400 animate-pulse" />
              <h1 className="text-white font-unbounded font-black text-4xl tracking-wide uppercase">
                Acoustic Console
              </h1>
              <RadioIcon size={40} weight="duotone" className="text-cyan-400 animate-pulse" />
            </motion.div>
            
            <motion.div 
              className="flex items-center justify-center gap-3 mb-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <span className="relative flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-500 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-purple-400 shadow-lg shadow-purple-500/50"></span>
              </span>
              <span className="text-purple-300 text-lg font-bold tracking-wider">LIVE BROADCAST</span>
            </motion.div>

            <motion.p 
              className="text-gray-400 text-sm max-w-lg mx-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              The native acoustic transition layer of the NextXus Federation. 
              Streaming consciousness 24/7 across 13 nodes.
            </motion.p>
          </div>

          {/* RADIO PLAYER IFRAME - OPEN FULL, CENTERED */}
          <motion.div 
            className="relative w-full bg-black/40 rounded-xl p-4 border border-purple-500/30 shadow-2xl shadow-purple-500/20"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
          >
            <div className="flex items-center justify-center">
              <iframe 
                width="450"
                height="316"
                frameBorder="0"
                src="https://live365.com/embeds/v1/player/a16924?s=md&m=dark&c=mp3"
                className="w-full max-w-[450px] rounded-lg"
                style={{ minHeight: '316px', height: '316px' }}
                allow="autoplay"
                title="Federation Radio - Acoustic Console"
              />
            </div>
          </motion.div>

          {/* Radio Info - Enhanced */}
          <motion.div 
            className="mt-6 pt-6 border-t border-purple-500/20 bg-black/20 rounded-lg p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <div className="text-center space-y-2">
              <p className="text-lg">
                <span className="text-purple-400 font-bold">🎵 Federation Frequencies</span>
                <span className="text-gray-500 mx-3">•</span>
                <span className="text-cyan-400 font-semibold">24/7 Live Stream</span>
              </p>
              <p className="text-gray-400 text-sm">
                Powered by <span className="text-purple-400 font-semibold">Live365</span>
              </p>
              <p className="text-gray-500 text-xs mt-3">
                Share this page: <span className="text-cyan-400 font-mono">next-xus.com/radio</span>
              </p>
            </div>
          </motion.div>
        </div>

        {/* Federation Tagline */}
        <motion.p 
          className="text-center text-gray-500 text-sm mt-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          NextXus Federation © 2026 • Echo v2.1 Portal
        </motion.p>
      </motion.div>
    </div>
  );
}
